import Lottie from 'lottie-react';
import animationData from '../../assets/lotties/ngi-logo.json';

type IProps = {
  customClassName?: string;
}

const Loader = ({ customClassName }: IProps) => {
  return (
    <div className={customClassName ? customClassName : " fixed left-0 top-0 w-screen h-screen flex items-center justify-center z-[999] [&_>_div>svg]:!h-[6.25rem]"}>
      <Lottie animationData={animationData} />
    </div>
  );
};

export default Loader;
